import Aos from "aos";
import "aos/dist/aos.css";
import {useEffect} from "react";

export default function Section( {animation, className, style, children, ...props} ){

    useEffect(()=>{
        //https://github.com/michalsnik/aos/tree/v2
        if (animation){
            Aos.init({
                duration: 500
            });
        }
    },[animation]);

    return (
        <div className={className} data-aos={animation} style={style}>{ children }</div>
    );
}
